import { Button, Modal, ModalCloseButton } from '@tryhackme/thm-ui-components';
import { useFormContext } from 'src/common/form';
import { StyledTitle } from 'src/features/admin/manage-users/modals/modals.styles';
import { TagForm } from 'src/features/admin/tagging/components/forms/tag-form-fields';
import { StyledActionButtonsWrapper, StyledFooterWrapper, StyledModalContents, StyledTag, StyledTagPreview } from 'src/features/admin/tagging/tagging.styles';
import type { AddTagModalProps, TagFormData } from 'src/features/admin/tagging/tagging.types';
export const AddTagModal = ({
  isOpen,
  setIsOpen,
  triggerElement,
  isCreating,
  tagCategories,
  handleCreateTag
}: AddTagModalProps) => {
  const {
    formState,
    clearErrors,
    handleSubmit,
    getValues,
    reset,
    watch
  } = useFormContext<TagFormData>();
  const closeModal = () => {
    setIsOpen(!isOpen);
    reset();
    clearErrors();
  };
  const handleSave = () => {
    const values = getValues();
    handleCreateTag({
      label: values.label,
      category: values.category.value,
      subcategory: values.subcategory?.value ?? null,
      colour: values.colour[0],
      weight: values.weight
    });
  };
  const [watchedLabel, watchedColour] = watch(['label', 'colour']);
  return <Modal open={isOpen} onOpenChange={closeModal} isSmall triggerElement={triggerElement} overflowVisible data-sentry-element="Modal" data-sentry-component="AddTagModal" data-sentry-source-file="add-tag-modal.tsx">
      <StyledModalContents data-testid="add-tag-modal-contents" data-sentry-element="StyledModalContents" data-sentry-source-file="add-tag-modal.tsx">
        <StyledTitle data-sentry-element="StyledTitle" data-sentry-source-file="add-tag-modal.tsx">Add New Tag</StyledTitle>
        <TagForm tagCategories={tagCategories} isCreating={isCreating} isModal data-sentry-element="TagForm" data-sentry-source-file="add-tag-modal.tsx" />
        <StyledFooterWrapper data-sentry-element="StyledFooterWrapper" data-sentry-source-file="add-tag-modal.tsx">
          <StyledTagPreview data-sentry-element="StyledTagPreview" data-sentry-source-file="add-tag-modal.tsx">
            <StyledTag $backgroundColor={watchedColour[1].backgroundColor} $fontColor={watchedColour[1].fontColor} $borderColor={watchedColour[1].borderColor} data-sentry-element="StyledTag" data-sentry-source-file="add-tag-modal.tsx">
              {watchedLabel || 'Preview...'}
            </StyledTag>
          </StyledTagPreview>
          <StyledActionButtonsWrapper data-sentry-element="StyledActionButtonsWrapper" data-sentry-source-file="add-tag-modal.tsx">
            <ModalCloseButton text="Cancel" data-sentry-element="ModalCloseButton" data-sentry-source-file="add-tag-modal.tsx" />
            <Button onClick={() => {
            // eslint-disable-next-line no-void
            void handleSubmit(handleSave)();
          }} disabled={!formState.isValid || isCreating} isLoading={isCreating} variant="solid" data-sentry-element="Button" data-sentry-source-file="add-tag-modal.tsx">
              Add Tag
            </Button>
          </StyledActionButtonsWrapper>
        </StyledFooterWrapper>
      </StyledModalContents>
    </Modal>;
};